import { mapReturningPartReason } from '@/utils/returningPartReasons'

export default {
	configuration: state => state.configuration,
	returningPartReasons: state => (state.returningPartReasons || []).map(mapReturningPartReason)
}
